import { render, staticRenderFns } from "./mine-bfb.vue?vue&type=template&id=3dbfeba2&scoped=true&"
import script from "./mine-bfb.vue?vue&type=script&lang=js&"
export * from "./mine-bfb.vue?vue&type=script&lang=js&"
import style0 from "./mine-bfb.vue?vue&type=style&index=0&id=3dbfeba2&prod&lang=scss&"
import style1 from "./mine-bfb.vue?vue&type=style&index=1&id=3dbfeba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbfeba2",
  null
  
)

export default component.exports